import { conditionLabel } from "@/lib/shop";

const base = "inline-flex items-center rounded-md border px-1.5 py-0.5 text-[10px] font-extrabold tracking-wide";

const STYLES = {
  ITA: "bg-blue-50 text-blue-700 border-blue-200",
  JP: "bg-rose-50 text-rose-700 border-rose-200",
  Sigillato: "bg-emerald-50 text-emerald-700 border-emerald-200",
  Singolo: "bg-amber-50 text-amber-800 border-amber-200",
  Usato: "bg-violet-50 text-violet-700 border-violet-200",
  EN: "bg-sky-50 text-sky-700 border-sky-200",
  CN: "bg-red-50 text-red-700 border-red-200",
  "Box/Display": "bg-orange-50 text-orange-700 border-orange-200",
  Mazzo: "bg-teal-50 text-teal-700 border-teal-200",
  Gradato: "bg-yellow-50 text-yellow-800 border-yellow-300",
};

export const ProductBadges = ({ p, className = "", compact = false }) => (
  <div className={`flex flex-wrap gap-1 ${className}`}>
    <span data-testid="badge-language" className={`${base} ${STYLES[p.language]}`}>{p.language}</span>
    {compact ? (
      p.condition === "Sigillato" ? <span data-testid="badge-sealed" className={`${base} ${STYLES.Sigillato}`}>Sealed</span>
        : p.condition === "Usato" ? <span data-testid="badge-used" className={`${base} ${STYLES.Usato}`}>{conditionLabel(p)}</span>
        : p.condition !== "Singolo" && <span data-testid="badge-type" className={`${base} ${STYLES[p.condition]}`}>{p.condition}</span>
    ) : (
      <span data-testid="badge-condition" className={`${base} ${STYLES[p.condition]}`}>{conditionLabel(p)}</span>
    )}
    {p.brand && (
      <span data-testid="badge-brand" className={`${base} bg-white text-slate-700 border-slate-300 tracking-normal font-bold`}>
        {p.brand}
      </span>
    )}
  </div>
);
